
import { Vue } from "vue-class-component";
export default class Logo extends Vue {}
